export function getTabTitleEl(): HTMLTitleElement {
  return document.getElementById('browser-title') as HTMLTitleElement;
}

export function changeTabTitle(title: string) {
  const tabTitle = getTabTitleEl();
  tabTitle.textContent = title;
}
